import React from 'react';
import { Box, Divider } from '@mui/material';
import { ReviewType, AssignmentBadgeFilter, AboutType } from '../../common/filters';

const MyAssignmentsFilters = ({
  selectedBadges,
  onBadgeToggle,
  selectedReviewTypes,
  onReviewTypeToggle,
  selectedAboutTypes,
  onAboutTypeToggle,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'center',
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flex: 1,
        flexWrap: 'wrap'
      }}>
        {/* Badge Filters */}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <AssignmentBadgeFilter
            selectedBadges={selectedBadges}
            onBadgeToggle={onBadgeToggle}
          />
        </Box>

        {/* Vertical Divider */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '32px',
            mx: 1,
            borderColor: '#CBD5E1'
          }}
        />

        {/* Review Type Filters */}
        <ReviewType
          selectedReviewTypes={selectedReviewTypes}
          onReviewTypeToggle={onReviewTypeToggle}
        />

        {/* Vertical Divider */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            height: '32px',
            mx: 1,
            borderColor: '#CBD5E1'
          }}
        />

        {/* About Type Filters */}
        <AboutType
          selectedAboutTypes={selectedAboutTypes}
          onAboutTypeToggle={onAboutTypeToggle}
        />
      </Box>
    </Box>
  );
};

export default MyAssignmentsFilters;
